import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import Chart from './MarblesChart.d3.js'
import ChartWrapper from '../ChartWrapper'

const MarblesChart = ({ tickers, group, isEmptyData, riskType, height }) => {
  const history = useHistory()
  const updateProps = useMemo(
    () => ({
      group,
      riskType,
      data: tickers,
    }),
    [group, riskType, tickers],
  )

  const chartHeight = height ?? (isMobile ? 350 : 500)

  return (
    <div style={{ height: chartHeight, width: '100%' }}>
      <ChartWrapper
        Chart={Chart}
        initProps={{
          data: tickers,
          redirect: history.push,
          group,
          isEmptyData,
          riskType,
        }}
        updateProps={updateProps}
        margin={{ TOP: 10, BOTTOM: 10, LEFT: 10, RIGHT: 10 }}
      />
    </div>
  )
}
export default MarblesChart
